<template>
  <div id="app">
    <router-view />
    <div @click="changePlayStatus($event)" class="play-box" :class="[!playStatus ? 'stop' : '']">
      <img v-if="playStatus" class="play" :class="[playStatus ? 'active' : '']" src="~@/assets/play.png" alt="" />
      <img v-else class="stop" src="~@/assets/stop.png" alt="" />
    </div>
    <audio id="audio" loop="loop" preload="auto" src="~@/assets/kouh5.mp3" autoplay="autoplay"></audio>
  </div>
</template>

<script>
export default {
  data() {
    return {
      playStatus: '',
      audio: null,
    }
  },
  mounted() {
    this.audio = document.getElementById('audio')
    this.initAudio()
  },
  methods: {
    changePlayStatus(e) {
      e.stopPropagation()
      if (this.playStatus) {
        this.audio.pause()
      } else {
        this.audio.play()
      }
      this.playStatus = !this.playStatus
    },
    initAudio() {
      document.addEventListener('WeixinJSBridgeReady', () => {
        if (this.audio.paused) {
          this.audio.play()
        }
      })
      this.audio.addEventListener('playing', () => {
        this.playStatus = true
        document.removeEventListener('click', this.firstClickPlayAudio)
      })
      this.audio.addEventListener('pause', () => {
        this.playStatus = false
      })
      const handler = () => {
        if (this.audio.paused) {
          this.audio.play()
          window.removeEventListener('touchstart', handler)
        }
      }
      window.addEventListener('touchstart', handler)
    },
  },
}
</script>

<style lang="scss">
html {
  margin: auto;
  /* width: 375px; */
  height: 100%;
  font-size: 10vw;
  font-family: -apple-system, system-ui, BlinkMacSystemFont, Helvetica Neue, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif;
}
body {
  margin: auto;
  height: 100%;
  font-size: 16px;
  -webkit-text-size-adjust: none !important;
  // background: #7c0106;
}
#app {
  height: 100%;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 24px;
}

@keyframes audioPlay {
  0% {
    transform: rotate(0);
    transform-origin: center center;
  }
  100% {
    transform: rotate(360deg);
    transform-origin: center center;
  }
}
.play-box {
  position: fixed;
  z-index: 10;
  top: 20px;
  right: 20px;
  @include MaxWidth {
    right: calc((100% - #{$maxWidth}) / 2 + 15px);
  }
  // &.stop {
  //     &::after {
  //         position: absolute;
  //         left: 8px;
  //         top: 8px;
  //         content: "";
  //         width: 44px;
  //         height: 44px;
  //         background: url("~@/assets/stop.png") no-repeat center/cover;
  //     }
  // }
  .stop {
    width: 59px;
    height: 59px;
  }
  .play {
    width: 59px;
    height: 59px;
    animation: audioPlay 2s linear infinite;
    animation-play-state: paused;
    &.active {
      animation-play-state: running;
    }
  }
}
</style>
